type QueryParams = Record<string, unknown>

/**
 * True when the previous route's query holds keys the target lacks.
 *
 * Only keys inherited from the previous route can trigger the carry-over:
 * counting keys the target *adds* would make the guard redirect to the same
 * location forever, because `from` never gains them on the retried navigation.
 * That loop aborted navigations to a route that adds a query param, such as
 * `?tab=queries` on the feature editor.
 */
export function hasMissingQueryParams(from: QueryParams, to: QueryParams): boolean {
  const toKeys = new Set(Object.keys(to))
  return Object.keys(from).some((key) => !toKeys.has(key))
}

/** Merge the previous route's query into the target; target values win. */
export function mergeQueryParams(from: QueryParams, to: QueryParams): QueryParams {
  return { ...from, ...to }
}
